import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';


function Aboutsect2() {
  // State to track active tab
  const [activeTab, setActiveTab] = useState('whatWeDo');

  // Function to handle tab click
  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
  };

  return (
    <div>
      <section className="py-5" id="tabs">
        <div className="container py-lg-5 py-md-4 py-2">
          <div className="text-center mb-5">
            <h6 className="text-primary mb-2">We Provide</h6>
            <h3 className="fw-bold mb-5">Specialization in Developing<br /> Business Strategy</h3>
          </div>
          
          <div className="row">
            <div className="col-lg-12 mx-auto">
              {/* Tab navigation */}
              <ul className="nav nav-tabs mb-4 justify-content-center" id="tabMenu" role="tablist">
                <li className="nav-item" role="presentation">
                  <button 
                    className={`nav-link px-4 py-3 ${activeTab === 'whatWeDo' ? 'active' : ''}`} 
                    onClick={() => handleTabClick('whatWeDo')}
                  >
                    What we do
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button 
                    className={`nav-link px-4 py-3 ${activeTab === 'mission' ? 'active' : ''}`} 
                    onClick={() => handleTabClick('mission')}
                  >
                    Our Mission
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button 
                    className={`nav-link px-4 py-3 ${activeTab === 'social' ? 'active' : ''}`} 
                    onClick={() => handleTabClick('social')}
                  >
                    Social impact
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button 
                    className={`nav-link px-4 py-3 ${activeTab === 'marketing' ? 'active' : ''}`} 
                    onClick={() => handleTabClick('marketing')}
                  >
                    Marketing
                  </button>
                </li>
              </ul>
              
              {/* Tab content */}
              <div className="tab-content">
                {/* What we do tab */}
                <div className={`tab-pane fade ${activeTab === 'whatWeDo' ? 'show active' : ''}`}>
                  <div className="row mt-4">
                    <div className="col-lg-6">
                      <h4 className="mb-3 fw-bold">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore</h4>
                      <p className="mb-4">Lorem ipsum dolor sit amet, elit. Id ab commodi impedit magnam sint voluptates. Minima velit expedita maiores, sit at in!</p>
                      <ul className="list-unstyled mt-4">
                        <li className="mb-3">
                          <i className="fa fa-check text-primary me-2"></i> Always Fast and friendly support
                        </li>
                        <li className="mb-3">
                          <i className="fa fa-check text-primary me-2"></i> We offer wide range of skills
                        </li>
                        <li className="mb-3">
                          <i className="fa fa-check text-primary me-2"></i> We help analyze,transform business models
                        </li>
                        <li className="mb-3">
                          <i className="fa fa-check text-primary me-2"></i> Experienced Professional Team
                        </li>
                        <li className="mb-3">
                          <i className="fa fa-check text-primary me-2"></i> consulting services include project management
                        </li>
                        <li className="mb-3">
                          <i className="fa fa-check text-primary me-2"></i> Manage your workflow and tasks successfully
                        </li>
                      </ul>
                    </div>
                    <div className="col-lg-6 ps-lg-5 mt-lg-0 mt-5">
                      <img src="/assets/images/g9.jpg" className="img-fluid rounded" alt="Business Team" />
                    </div>
                  </div>
                </div>
                
                {/* Our Mission tab */}
                <div className={`tab-pane fade ${activeTab === 'mission' ? 'show active' : ''}`}>
                  <div className="row mt-4">
                    <div className="col-lg-6">
                      <img src="/assets/images/g3.jpg" className="img-fluid rounded" alt="Our Mission" />
                    </div>
                    <div className="col-lg-6 ps-lg-5 mt-lg-0 mt-5">
                      <h4 className="mb-3 fw-bold">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore</h4>
                      <p className="mb-4">Lorem ipsum dolor sit amet, elit. Id ab commodi impedit magnam sint voluptates. Minima velit expedita maiores, sit at in!</p>
                      <ul className="list-unstyled mt-4">
                        <li className="mb-3">
                          <i className="fa fa-check text-primary me-2"></i> Always Fast and friendly support
                        </li>
                        <li className="mb-3">
                          <i className="fa fa-check text-primary me-2"></i> Experienced Professional Team
                        </li>
                        <li className="mb-3">
                          <i className="fa fa-check text-primary me-2"></i> Always Fast and friendly support
                        </li>
                        <li className="mb-3">
                          <i className="fa fa-check text-primary me-2"></i> Experienced Professional Team
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                
                {/* Social impact tab */}
                <div className={`tab-pane fade ${activeTab === 'social' ? 'show active' : ''}`}>
                  <div className="row mt-4">
                    <div className="col-lg-6">
                      <h4 className="mb-3 fw-bold">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore</h4>
                      <p className="mb-4">Lorem ipsum dolor sit amet, elit. Id ab commodi impedit magnam sint voluptates. Minima velit expedita maiores, sit at in!</p>
                      <ul className="list-unstyled mt-4">
                        <li className="mb-3">
                          <i className="fa fa-check text-primary me-2"></i> Always Fast and friendly support
                        </li>
                        <li className="mb-3">
                          <i className="fa fa-check text-primary me-2"></i> We offer wide range of skills
                        </li>
                        <li className="mb-3">
                          <i className="fa fa-check text-primary me-2"></i> We help analyze,transform business models
                        </li>
                        <li className="mb-3">
                          <i className="fa fa-check text-primary me-2"></i> Experienced Professional Team
                        </li>
                        <li className="mb-3">
                          <i className="fa fa-check text-primary me-2"></i> consulting services include project management
                        </li>
                        <li className="mb-3">
                          <i className="fa fa-check text-primary me-2"></i> Manage your workflow and tasks successfully
                        </li>
                      </ul>
                    </div>
                    <div className="col-lg-6 ps-lg-5 mt-lg-0 mt-5">
                      <img src="/assets/images/g8.jpg" className="img-fluid rounded" alt="Social Impact" />
                    </div>
                  </div>
                </div>
                
                {/* Marketing tab */}
                <div className={`tab-pane fade ${activeTab === 'marketing' ? 'show active' : ''}`}>
                  <div className="row mt-4">
                    <div className="col-lg-6">
                      <img src="/assets/images/g7.jpg" className="img-fluid rounded" alt="Marketing" />
                    </div>
                    <div className="col-lg-6 ps-lg-5 mt-lg-0 mt-5">
                      <h4 className="mb-3 fw-bold">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore</h4>
                      <p className="mb-4">Lorem ipsum dolor sit amet, elit. Id ab commodi impedit magnam sint voluptates. Minima velit expedita maiores, sit at in!</p>
                      <ul className="list-unstyled mt-4">
                        <li className="mb-3">
                          <i className="fa fa-check text-primary me-2"></i> Always Fast and friendly support
                        </li>
                        <li className="mb-3">
                          <i className="fa fa-check text-primary me-2"></i> Experienced Professional Team
                        </li>
                        <li className="mb-3">
                          <i className="fa fa-check text-primary me-2"></i> Always Fast and friendly support
                        </li>
                        <li className="mb-3">
                          <i className="fa fa-check text-primary me-2"></i> Experienced Professional Team
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Aboutsect2;